import React, { useEffect, useState } from 'react';

import SatSelect from '@components/common/satUI/SatSelect';

const OldIncomeAge = props => {
  const {
    oldIncomeAge,
    oldIncomeMinAge,
    oldIncomeMaxAge,
    insuranceAge,
    mainProduct: { payinPeriodTypeCode, payinPeriodValue },
    onChangeAge,
  } = props;

  const [ageOptions, setAgeOptions] = useState([]);

  useEffect(() => {
    let array = [];

    const minAge = Math.max(
      payinPeriodTypeCode === '1'
        ? insuranceAge + parseInt(payinPeriodValue)
        : parseInt(payinPeriodValue),
      insuranceAge + 15,
      oldIncomeMinAge,
    );

    for (let i = minAge; i <= oldIncomeMaxAge; i++) {
      array = array.concat({ label: `${i}세`, value: i });
    }

    setAgeOptions(array);
    onChangeAge({ value: minAge });
  }, [
    oldIncomeMinAge,
    oldIncomeMaxAge,
    insuranceAge,
    payinPeriodTypeCode,
    payinPeriodValue,
  ]);

  return (
    <div className="cell-col2">
      <div className="cell">
        <div className="tit-area">
          <h2 className="tit-con">노후소득개시나이</h2>
        </div>
        <SatSelect
          value={oldIncomeAge}
          name={'oldIncomeAge'}
          title="노후소득개시나이"
          width="11rem"
          options={ageOptions}
          onChange={onChangeAge}
        />
      </div>
    </div>
  );
};

export default React.memo(OldIncomeAge);
